let pageUnloading = false;
window.addEventListener('beforeunload', () => {
  pageUnloading = true;
});

document.addEventListener('DOMContentLoaded', function() {

  // Safely retrieves the stored array for a key and returns a comma-separated string.
  function getStoredArray(key) {
    const stored = localStorage.getItem(key);
    if (!stored) return null;
    try {
      const parsed = JSON.parse(stored);
      if (Array.isArray(parsed)) {
        return parsed.join(',');
      }
    } catch(e) {
      console.error('Error parsing JSON for key', key, e);
    }
    return null;
  }

  // Reduces whatever the seller typed or autofilled ("(303) 555-0123", "303-555-0123",
  // "+1 303 555 0123") to 10 digits. Returns null unless it is a US-shaped number
  // (area code and exchange start with 2-9), the same numbers NEXUS accepts.
  function normalizePhone(raw) {
    let digits = String(raw || '').replace(/\D/g, '');
    if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
    return /^[2-9]\d{2}[2-9]\d{6}$/.test(digits) ? digits : null;
  }

  // Counts in GA4 how often the phone needed fixing, so the lead check can see it.
  function trackPhone(eventName) {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', eventName, { send_to: 'G-T4XK8YLH17' });
    } catch (e) {
      console.error('GA4 event failed', e);
    }
  }

  // A double tap on "Get Started" sends one sign-up, not two.
  let lastSentPhone = null;
  let lastSentAt = 0;
  let lastPhoneAlertAt = 0;

  document.body.addEventListener('click', function(event) {
    // closest(): a tap on the button's inner spinner span still counts as the button.
    const submitButton = event.target && event.target.closest ? event.target.closest('.wizard__submit') : null;
    if (submitButton) {
      const phoneInput = document.getElementById('54806-phone-1');
      const phoneNumber = normalizePhone(phoneInput.value);

      // Validate the phone number first.
      if (!phoneNumber) {
        event.preventDefault();
        // One tap can reach this twice; the seller sees one alert.
        if (Date.now() - lastPhoneAlertAt < 2000) return;
        lastPhoneAlertAt = Date.now();
        trackPhone('seller_phone_rejected');
        alert('It looks like your phone number might be wrong. Please enter a 10-digit US phone number. Ex: 303-555-0123');
        return;
      }
      // The old check refused any number typed with dashes, spaces, brackets or +1.
      if (phoneInput.value !== phoneNumber) trackPhone('seller_phone_reformatted');
      phoneInput.value = phoneNumber;

      // Gather data from the form and localStorage.
      const data = {
        firstName: document.getElementById('54806-text-2').value,
        lastName: document.getElementById('54806-text-3').value,
        phoneNumber: phoneNumber,
        zipCode: document.getElementById('54806-number-1').value,
        donateEarnings: document.getElementById('54806-checkbox-2-Donated Proceeds? ❤️-').checked,
        terms: document.getElementById('54806-acceptTerms-2').checked,
        hearAboutUs: document.getElementById('54806-select-1').value,
        otherExplanation: document.getElementById('54806-text-1').value,
        friendWhoReferred: document.getElementById('54806-text-4').value,
        gclid: localStorage.getItem('gclid') || null,
        fbclid: localStorage.getItem('fbclid') || null,
        keyword: getStoredArray('keyword'),
        referrer: localStorage.getItem('referrer') || null,
        landingPage: localStorage.getItem('landing_page') || null,
        utmSource: getStoredArray('utm_source'),
        utmMedium: getStoredArray('utm_medium'),
        utmCampaign: getStoredArray('utm_campaign'),
        utmContent: getStoredArray('utm_content'),
        sellerReferrer: getStoredArray('seller_referrer'),
        lpTestVariant: getStoredArray('lp_test_variant'),
      };

      // Check for required fields.
      if (!data.firstName || !data.lastName || !data.phoneNumber || !data.zipCode || !data.terms || !data.hearAboutUs) {
        event.preventDefault();
        return;
      }

      // Ignore a second tap with the same phone within 10 seconds.
      const now = Date.now();
      if (lastSentPhone === phoneNumber && now - lastSentAt < 10000) return;
      lastSentPhone = phoneNumber;
      lastSentAt = now;

      // Send the data to your database using fetch with keepalive.
      // NEXUS answers 204 (no body) on success, 400 for a number it cannot text,
      // 429 after too many tries.
      fetch('https://nexus.secondedition.co/webhook/sign-up-submission', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
        keepalive: true,
      })
      .then(response => {
        if (response.ok) {
          console.log('Success:', response.status);
          return;
        }
        lastSentPhone = null;
        if (response.status === 400) {
          alert('We can\'t text that number. Please enter a valid US mobile number.');
        } else if (response.status === 429) {
          alert('Too many tries in a short time. Please wait a few minutes and try again.');
        } else {
          alert('Looks like there was an error. Please try again and contact support if it still doesn\'t work.');
        }
      })
      .catch(error => {
        lastSentPhone = null;
        console.error('Error:', error);
      });
      // Allow the default button redirect to occur.
    }
  });
});
